<template>
  <div class="addPage">
    <div class="header" style="margin: 10px 0">
      <div class="title">
        <span
          @click="back"
          style="cursor: pointer; color: #4587ff; margin-right: 20px"
          ><i class="el-icon-arrow-left"></i>返回</span
        >
        新增专业服务
      </div>
    </div>
    <div>
      <el-steps :active="active" align-center finish-status="success">
        <el-step title="基本信息"></el-step>
        <el-step title="服务项目"></el-step>
        <el-step title="流程节点"></el-step>
      </el-steps>
      <!-- 基本信息 -->
      <div class="food_content" v-if="active == 1">
        <el-form label-width="150px" :model="formLabelAlign">
          <el-form-item label="专业服务名称">
            <el-input
              placeholder="请输入专业服务名称"
              v-model="formLabelAlign.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="专业服务介绍">
            <el-input
              type="textarea"
              placeholder="请输入专业服务介绍"
              v-model="formLabelAlign.brief"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户填写相关要求">
            <el-input
              type="textarea"
              placeholder="请输入相关要求"
              v-model="formLabelAlign.requirements"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传服务相关的资料">
            <el-button size="small" @click="uploads" type="primary"
              >点击上传</el-button
            >
            <div v-if="fileList.length > 0">
              <div class="loadbox" v-for="v in fileList" :key="v">
                {{ v }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="联系方式">
            <el-input
              placeholder="请输入联系方式"
              v-model="formLabelAlign.contact"
            ></el-input>
          </el-form-item>
        </el-form>
        <div @click="onSubmit" class="foo_btn">提交</div>
      </div>
      <!-- 服务项目 -->
      <div class="food_contents" v-if="active == 2">
        <div
          class="select_box"
          v-for="(el, i) in ser_list"
          :key="i"
          @click="editData(el)"
        >
          <div class="">
            {{ el.projectName }}
          </div>
          <div class="center_box">
            <div style="font-size: 13px; color: #999">
              {{ el.createTime }}
            </div>
            <div @click.stop="delServices(el)" class="sanchu">
              <img :src="$store.state.wqurl + 'editedBooks_del.png'" mode="" />
              删除
            </div>
          </div>
          <div
            style="
              color: #326afb;
              font-weight: 600;
              cursor: pointer;
              font-size: 15px;
            "
            @click.stop="goFlowPath(el, 3)"
          >
            流程节点配置
          </div>
        </div>
        <div class="kong" v-if="ser_list.length < 1">
          <img src="@/assets/ai-ct.png" alt="" />
          <div>没有找到服务项目</div>
        </div>
        <div @click="adds" class="foo_btns">新增服务项目</div>
      </div>
      <div class="food_contents" v-if="active == 3">
        <div class="fuw_box">
          <div
            class="fuw_first"
            style="min-height: 150px; width: 100%; margin-bottom: 10px"
          >
            <div
              class="select_box1"
              v-for="(el, i) in flow_list"
              :key="i"
              @click="clickXuig(el)"
            >
              {{ el.specsName }}

              <div class="rights">
                <span @click.stop="delFlowPath(el)" style="color: #eb3828"
                  >删除</span
                >
                <div
                  style="display: flex; align-items: center; margin-left: 15px"
                >
                  <span style="margin-right: 3px">修改</span>
                </div>
              </div>
            </div>
            <div class="kong" v-if="flow_list.length < 1">
              <img src="@/assets/ai-ct.png" alt="" />
              <div>没有找到流程节点</div>
            </div>
          </div>
          <div class="add_services" @click="xinZ()">新增流程节点</div>
          <div class="back_list" @click="goFlowPath('', 2)">
            返回专业服务列表
          </div>
        </div>
      </div>
    </div>
    <!-- 流程弹框 -->
    <el-dialog
      title="新增流程节点"
      width="30%"
      :visible.sync="dialogTableVisible"
    >
      <div>
        <div class="ask_task">
          <div class="">
            <span style="color: red; margin-right: 5px">*</span> 流程名称
          </div>
          <div class="textarea_box">
            <textarea
              v-model="formData.specsName"
              style="border: none; height: 60px; width: 100%"
              placeholder="请填写流程名称"
              :maxlength="150"
            ></textarea>
          </div>
        </div>

        <div class="ask_task">
          <div class="">
            <span style="color: red; margin-right: 5px">*</span> 服务规范
          </div>
          <div class="textarea_box">
            <textarea
              v-model="formData.serviceSpecification"
              style="border: none; height: 60px; width: 100%"
              placeholder="请填写服务规范"
              placeholder-style="color:#999;font-size:15px;"
              :maxlength="150"
            ></textarea>
          </div>
        </div>

        <div class="ask_task">
          <div class="">
            <span style="color: red; margin-right: 5px">*</span> 交付成果
          </div>
          <div class="textarea_box">
            <textarea
              v-model="formData.deliverables"
              style="border: none; height: 60px; width: 100%"
              placeholder="请填写交付成果"
              placeholder-style="color:#999;font-size:15px;"
              :maxlength="150"
            ></textarea>
          </div>
        </div>

        <div class="select_box1">
          <div class="" style="color: #333; margin-right: 5px">完成时限</div>
          <div class="">
            <el-input-number
              v-model="formData.deadline"
              :min="1"
              label="请选择时间"
            ></el-input-number>
          </div>
        </div>

        <div class="select_box1" style="margin-bottom: 25px">
          <div class="" style="color: #333">
            <span style="color: red">*</span> 本流程价格
          </div>
          <div class="" style="">
            <span style="margin-right: 7px">￥</span>
            <input
              v-model="formData.price"
              type="text"
              style="width: 80px"
              placeholder="请输入价格"
            />
          </div>
        </div>

        <div class="operate_but">
          <div
            class="apply_but clickText"
            @click="
              dialogTableVisible = false
              formData = {}
            "
          >
            取消
          </div>
          <div
            class="click_but clickText"
            @click="type === 1 ? submitData() : updateServicesFlowPath()"
          >
            提交
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProjectProcess,
  deleteServicesFlowPath,
  addProjectProcess,
} from 'api/professionServer'
import qs from 'qs'
export default {
  props: ['active', 'ser_list', 'formLabelAlign', 'fileList'],
  data() {
    return {
      type: 1,
      det_data: {},
      formData: {},
      showTimeType: '',
      // 流程节点
      flow_list: [],
      dialogTableVisible: false,
      imgUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/',
    }
  },
  created() {
    console.log(this.formLabelAlign)
  },
  methods: {
    xinZ() {
      this.dialogTableVisible = true
      this.type = 1
      this.formData = {
        specsName: '',
        deliverables: '',
        deadline: 1,
        serviceSpecification: '',
        price: '',
      }
      // this.is_flowPath = true;
    },
    async submitData() {
      if (JSON.stringify(Number(this.formData.price)) === JSON.stringify(NaN)) {
        this.$message.error('请输入正确的价格')

        return
      }

      if (Number(this.formData.price) <= 0) {
        this.$message.error('价格不能小于等于0')

        return
      }

      let list = Object.keys(this.formData).filter((el) => !this.formData[el])

      if (list.length > 0) {
        this.$message.error('请将信息填写完整')

        return
      }

      let opt = {
        ...this.formData,
        price: Number(this.formData.price),
        projectId: this.formLabelAlign.id || this.det_data.id,
      }
      let res = await addProjectProcess(opt)
      if (res.code !== 200) return this.$message.error(res.data)
      this.dialogTableVisible = false
      this.getProjectProcess()
      this.$alert(
        '您提交的专业服务任务正在审核中,审核结果将会在1个小时内以短信的方式通知您，请耐心等候!',
        '提示',
        {
          confirmButtonText: '确定',
          callback: (action) => {},
        }
      )
    },
    clickXuig(el) {
      this.type = 2
      this.xz_flowItem = el
      this.formData = {
        specsName: el.specsName,
        deliverables: el.deliverables,
        deadline: el.deadline,
        serviceSpecification: el.serviceSpecification,
        price: el.price,
      }
      this.dialogTableVisible = true
    },
    // 删除流程节点
    delFlowPath(item) {
      this.$confirm('是否删除该流程节点', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await deleteServicesFlowPath(
            qs.stringify({
              id: item.id,
            })
          )
          if (res.code !== 200) return
          this.getProjectProcess()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 获取流程节点
    async getProjectProcess(id) {
      console.log(id)
      let res = await getProjectProcess(
        this.formLabelAlign.id || this.det_data.id
      )
      if (res.code !== 200) return
      this.flow_list = res.data
    },

    goFlowPath(v, id) {
      this.det_data = v
      this.$parent.active = id
      if (id == 3) {
        this.getProjectProcess(v.id)
      }
    },
    back() {
      this.$parent.addShow = false
      this.$parent.servicesProductList(this.$parent.tarid)
    },
    uploads() {
      this.$emit('uploads')
    },
    delServices(v) {
      this.$emit('delServices', v)
    },
    editData(v) {
      this.$emit('editData', v)
    },
    onSubmit() {
      this.$emit('onSubmit')
    },
    adds() {
      this.$parent.dialogVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.addPage {
  .food_content {
    max-height: 520px;
    overflow-y: auto;
    padding: 30px 80px 20px 20px;
    box-sizing: border-box;
    .loadbox {
      height: 30px;
      color: #666;
      font-size: 12px;
    }
    .foo_btn {
      cursor: pointer;
      width: 200px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-color: #4587ff;
      border-radius: 4px;
      margin: 60px auto 0;
      color: #fff;
    }
  }
  .food_contents {
    max-height: 520px;
    overflow-y: auto;

    .add_services {
      cursor: pointer;
      margin: 0 auto;
      width: 50%;
      height: 50px;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #326afb;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      color: #326afb;
    }

    .back_list {
      cursor: pointer;
      margin: 0 auto;
      width: 50%;
      height: 50px;
      box-sizing: border-box;
      background: #326afb;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      margin-top: 15px;
    }
    .kong {
      font-size: 13px;
      margin: 100px 0;
      color: #333;
      text-align: center;
      img {
        width: 100px;
      }
    }
    .select_box1 {
      width: 100%;
      display: flex;
      height: 50px;
      line-height: 50px;
      background: #f7f8fa;
      align-content: center;
      padding: 0 20px;
      box-sizing: border-box;
      margin-bottom: 30px;
      justify-content: space-between;
      .rights {
        display: flex;
        align-items: center;
        span {
          cursor: pointer;
          margin: 0 20px;
        }
      }
    }
    .select_box {
      width: 100%;
      min-height: 50px;
      background: #f7f8fa;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      padding: 15px;
      // align-items: center;
      box-sizing: border-box;
      margin-bottom: 10px;

      > div:first-child {
        font-weight: 600;
        font-size: 17px;
        color: #000;
      }

      .center_box {
        font-size: 15px;
        color: #666666;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 14px 0;

        .sanchu {
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
        }
      }

      .shuxian {
        width: 3px;
        height: 17px;
        background-color: #b5b5b5;
        margin: 0 10px;
      }
    }
    .foo_btns {
      cursor: pointer;
      width: 200px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background-color: #fff;
      border: 1px solid #326afb;
      border-radius: 4px;
      margin: 60px auto 0;
      color: #326afb;
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    .tit_box {
      font-size: 16px;
      font-weight: bold;
      color: #000000;

      display: flex;
      align-items: center;
      justify-content: space-between;
      .tip {
        font-size: 12px;
        font-weight: normal;
        color: #333;
        > text {
          color: #326afb;
        }
      }
    }
    .title {
      position: relative;
      font-size: 16px;
      width: 100%;
      font-family: Microsoft YaHei;
      font-weight: 600;
      color: #333333;
      .el-button {
        position: absolute;
        top: -10px;
        right: 0;
      }
    }
    .more {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      cursor: pointer;
    }
  }
}
.ask_task {
  width: 100%;
  min-height: 110px;
  border-radius: 10px;
  padding: 15px 15px 5px;
  box-sizing: border-box;
  margin-bottom: 10px;
  textarea {
    border: 2px solid #999 !important;
    padding: 15px;
    box-sizing: border-box;
    border-radius: 4px;
    background-color: #fff;
    /*去掉右下角拖拽*/
    resize: none;
  }

  > div:first-child {
    font-weight: 600;
    font-size: 15px;
    color: #333;
  }

  > div:last-child {
    width: 100%;
    margin-top: 10px;
  }
  .fuw_box {
    margin-bottom: 10px;
  }
}
.select_box1 {
  width: 100%;
  min-height: 50px;
  background: #f7f8fa;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 10px;

  > div:first-child {
    font-weight: 600;
    font-size: 15px;
    color: #326afb;
  }

  > div:last-child {
    font-size: 15px;
    color: #666666;
    display: flex;
    align-items: center;
    // vertical-align: ;
  }

  .shuxian {
    width: 2px;
    height: 17px;
    background-color: #b5b5b5;
    margin: 0 10px;
  }
}
.operate_but {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  > div {
    width: 49%;
    height: 45px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-size: 16px;
  }

  .apply_but {
    cursor: pointer;
    border: 1px solid #326afb;
    background-color: #fff;
    color: #326afb;
  }

  .click_but {
    cursor: pointer;
    background-color: #326afb;
    font-weight: 600;
    color: #fff;
  }
}
</style>
